var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex gap-20 justify-content-between flex-wrap" },
    [
      _c("div", { staticClass: "d-flex gap-20" }, [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "50",
              height: "50",
              viewBox: "0 0 50 50",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M49.8403 16.4347C49.8403 8.86524 43.7042 2.72913 36.1361 2.72913C31.5417 2.72913 27.4875 4.99718 25 8.46385C22.5125 4.99718 18.4583 2.72913 13.8653 2.72913C6.29584 2.72913 0.159729 8.86385 0.159729 16.4347C0.159729 17.5069 0.29584 18.5458 0.529173 19.5472C2.43195 31.3708 15.5778 43.8444 25 47.2694C34.4208 43.8444 47.5681 31.3708 49.4681 19.5486C49.7042 18.5472 49.8403 17.5083 49.8403 16.4347Z",
                fill: "#DD2E44",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M47.7042 33.1861L42.393 31.2194L40.4264 25.9083C40.3281 25.642 40.1506 25.4122 39.9178 25.2498C39.6849 25.0875 39.4079 25.0003 39.1241 25.0002C38.8402 25 38.5631 25.0869 38.3301 25.249C38.0971 25.4111 37.9194 25.6407 37.8208 25.9069L35.8542 31.2181L30.543 33.1847C30.2774 33.2837 30.0483 33.4616 29.8866 33.6944C29.7249 33.9273 29.6382 34.204 29.6382 34.4875C29.6382 34.771 29.7249 35.0477 29.8866 35.2806C30.0483 35.5134 30.2774 35.6913 30.543 35.7903L35.8542 37.7569L37.8208 43.0681C37.9192 43.3343 38.0968 43.564 38.3298 43.7263C38.5627 43.8885 38.8397 43.9755 39.1236 43.9755C39.4075 43.9755 39.6845 43.8885 39.9174 43.7263C40.1504 43.564 40.328 43.3343 40.4264 43.0681L42.393 37.7569L47.7042 35.7903C47.9694 35.691 48.1979 35.5132 48.3593 35.2805C48.5207 35.0478 48.6071 34.7714 48.6071 34.4882C48.6071 34.205 48.5207 33.9286 48.3593 33.6959C48.1979 33.4632 47.9694 33.2854 47.7042 33.1861ZM15.7597 10.9625L12.475 9.74723L11.2597 6.4625C11.1613 6.19624 10.9837 5.96652 10.7508 5.80428C10.5178 5.64203 10.2408 5.55505 9.95693 5.55505C9.67307 5.55505 9.39602 5.64203 9.1631 5.80428C8.93017 5.96652 8.75255 6.19624 8.65415 6.4625L7.43749 9.74723L4.15415 10.9625C3.88789 11.0609 3.65817 11.2385 3.49593 11.4714C3.33368 11.7044 3.2467 11.9814 3.2467 12.2653C3.2467 12.5491 3.33368 12.8262 3.49593 13.0591C3.65817 13.292 3.88789 13.4697 4.15415 13.5681L7.43888 14.7833L8.65415 18.0681C8.75255 18.3343 8.93017 18.564 9.1631 18.7263C9.39602 18.8885 9.67307 18.9755 9.95693 18.9755C10.2408 18.9755 10.5178 18.8885 10.7508 18.7263C10.9837 18.564 11.1613 18.3343 11.2597 18.0681L12.475 14.7833L15.7597 13.5681C16.026 13.4697 16.2557 13.292 16.4179 13.0591C16.5802 12.8262 16.6672 12.5491 16.6672 12.2653C16.6672 11.9814 16.5802 11.7044 16.4179 11.4714C16.2557 11.2385 16.026 11.0609 15.7597 10.9625Z",
                fill: "#FDCB58",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c("strong", { staticClass: "font-size-125" }, [
            _vm._v(_vm._s(_vm._f("trans")("Want to support us?"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "font-size-125" }, [
            _vm._v(
              _vm._s(
                _vm._f("trans")(
                  "Let friends in on the secret and share your new favorite tool!"
                )
              )
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-social-wrapper flex-lg-nowrap flex-wrap w-100" },
        [
          _c(
            "button",
            {
              staticClass: "btn-social btn-facebook d-flex align-items-center",
              on: {
                click: function ($event) {
                  return _vm.share("facebook")
                },
              },
            },
            [
              _c("span", { staticClass: "icon-container icon-facebook" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47 14 5.5 16 5.5H17.5V2.14C17.174 2.097 15.943 2 14.643 2C11.928 2 10 3.657 10 6.7V9.5H7V13.5H10V22H14V13.5Z",
                        fill: "white",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "button-text fb-color" }, [
                _vm._v(_vm._s(_vm._f("trans")("Facebook"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-social btn-twitter d-flex align-items-center",
              on: {
                click: function ($event) {
                  return _vm.share("twitter")
                },
              },
            },
            [
              _c("span", { staticClass: "icon-container icon-twitter" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "-4 -2 22 22",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M14.1747 0.86438H16.9361L10.9048 7.75617L18 17.1356H12.4459L8.09257 11.4485L3.11734 17.1356H0.352021L6.80183 9.76268L0 0.86438H5.69492L9.62582 6.06255L14.1747 0.86438ZM13.2047 15.485H14.734L4.8618 2.42892H3.21904L13.2047 15.485Z",
                        fill: "white",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "button-text tw-color" }, [
                _vm._v(_vm._s(_vm._f("trans")("Twitter"))),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-social btn-linkedin d-flex align-items-center",
              on: {
                click: function ($event) {
                  return _vm.share("linkedin")
                },
              },
            },
            [
              _c("span", { staticClass: "icon-container icon-linkedin" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M6.94 5.00002C6.93974 5.53046 6.72877 6.03906 6.35351 6.41394C5.97825 6.78883 5.46944 6.99929 4.939 6.99902C4.40857 6.99876 3.89997 6.78779 3.52508 6.41253C3.1502 6.03727 2.93974 5.52846 2.94 4.99802C2.94027 4.46759 3.15124 3.95899 3.5265 3.5841C3.90176 3.20922 4.41057 2.99876 4.941 2.99902C5.47144 2.99929 5.98004 3.21026 6.35492 3.58552C6.72981 3.96078 6.94027 4.46959 6.94 5.00002ZM7 8.48002H3V21H7V8.48002ZM13.32 8.48002H9.34V21H13.28V14.43C13.28 10.77 18.05 10.43 18.05 14.43V21H22V13.07C22 6.90002 14.94 7.13002 13.28 10.16L13.32 8.48002Z",
                        fill: "white",
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("strong", { staticClass: "button-text li-color" }, [
                _vm._v(_vm._s(_vm._f("trans")("LinkedIn"))),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }